// Rejected entries from a bulk add, e.g.
// "IS20260731_BXJ46C: Already on an open work order (WO20260715_9EHXRW)".
export function rejectedIssuesMessage(rejected, issueCodeById = {}) {
	const lines = rejected.map(({ issueId, reason, workOrderCode }) => {
		const code = issueCodeById[issueId] ?? issueId;
		const onWorkOrder = workOrderCode ? ` (${workOrderCode})` : "";
		return `${code}: ${reason}${onWorkOrder}`;
	});
	return `Not added: ${lines.join("; ")}`;
}
